<template>
  <div class="renedian-very-light-sand--background">
    <!-- Header: Desktop & Mobile -->
    <div class="d-md-flex flex-column">
      <!-- Dark Brown Tear: Desktop -->
      <img class="d-none d-md-flex width-100 renedian-very-light-sand--background" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Fheader%2Ftop-tear.png?alt=media&token=a241a0b9-353e-45e0-aff8-14e19eee211d" alt="" />
      <!-- Dark Brown Tear: Mobile -->
      <img class="width-100 renedian-very-light-sand--background d-flex d-md-none" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Fheader%2Ftop-tear-brown.png?alt=media&token=2a80a1ad-2903-4a81-abe5-d0870377d050" alt="" />
      <!-- Dark Brown Bar -->
      <div class="d-flex renedian-dark-brown--background width-100 align-center justify-center" style="min-height: 30px">
        <div class="renedian-sand--text barlow-condensed-regular-italic text-center font-size-sm py-2">
          <nav v-if="breadcrumbItems.length" class="breadcrumb-nav" aria-label="Breadcrumb">
            <span v-for="(item, i) in breadcrumbItems" :key="`${i}-${item.label}`">
              <router-link
                v-if="item.isLink"
                class="breadcrumb-item breadcrumb-link"
                :to="item.to"
                v-text="item.label"
              ></router-link>
              <span v-else class="breadcrumb-item" v-text="item.label"></span>
              <span v-if="i < breadcrumbItems.length - 1" class="breadcrumb-separator">/</span>
            </span>
          </nav>
          <span v-else>{{ breadcrumb }}</span>
        </div>
      </div>
      <!-- Light Brown Bar -->
      <div class="d-flex renedian-brown--background width-100 align-center justify-center">
        <div class="d-flex renedian-sand--text text-uppercase true-north justify-center font-size-xl text-center">
          {{ title }}
        </div>
      </div>
      <!-- Super Hero -->
      <div class="d-flex flex-column position-relative">
        <!-- Light Brown Rip: Desktop -->
        <img class="position-absolute width-100 d-none d-md-flex z-index-1 top-0" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Fheader%2Fbottom-tear-brown.png?alt=media&token=ce7ffee3-0470-458c-8672-5be7d361338a" alt="" />
        <!-- Light Brown Rip: Mobile -->
        <img class="position-absolute width-100 d-flex d-md-none z-index-1 top-0" src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Fheader%2Fbottom-tear-mobile.png?alt=media&token=3d786ff5-e92f-46f2-9111-134ce4f9fafe" alt="" />
        <!-- Hero -->
        <div v-if="heroImage || carousel?.length" class="d-flex position-relative">
          <!-- Badge-->
          <div v-if="badgeImage" class="d-flex position-absolute z-index-2 carousel-badge">
            <v-img :src="vImg(badgeImage, 400)" width="14vw" max-width="300px" style="filter: drop-shadow(0 4px 16px rgba(0,0,0,0.3));" alt="" />
          </div>
          <!-- <div class="d-flex position-absolute z-index-2 slogan-image">
            <v-img src="https://firebasestorage.googleapis.com/v0/b/renedian-production.appspot.com/o/images%2Flanding%2FSlogan%20-%20Africa.svg?alt=media&token=72c3637c-c3e9-4cc0-8a67-b09f57c30a30"></v-img>
          </div> -->
          <v-img
            v-if="heroImage"
            :src="vImg(heroImage)"
            class="article-cover-image elevation-2" 
            :aspect-ratio="3000/1776"
            cover
            :alt="title"
          ></v-img>
          <v-img
            v-else-if="carousel?.length == 1"
            :src="vImg(carousel[0].url)"
            class="article-cover-image elevation-2" 
            :aspect-ratio="3000/1776"
            cover
            eager
            :alt="title"
          ></v-img>
          <v-carousel 
            v-else-if="carousel?.length > 1"
              v-model="model" 
              hide-delimiter-background 
              show-arrows-on-hover 
              continuous 
              cycle
              class="carousel-header"
              :interval="3000"
          >
            <v-carousel-item
              v-for="(item, i) in carousel"
              :key="item.url"
              hide-delimiter-background
              class="elevation-2"
            >
              <v-img 
                :src="vImg(item.url)" 
                :aspect-ratio="3000/1776"
                cover
                :eager="i === 0"
                class="carousel-image"
                :alt="title"
              ></v-img>
            </v-carousel-item>
          </v-carousel>
        </div>
        <!-- Loading Progress Bar -->
        <v-progress-linear  
          v-if="imagesLoading"
          :value="loadingProgress"
          color="orange darken-3"
          height="4"
          class="progress-bar"
        ></v-progress-linear>
      </div>
    </div>
  </div>
</template>
<script>
import { vuetifySrc, resizedUrl } from '@/utils/imageProxy'

export default {
  name: 'RippedHeader',
  props: {
    breadcrumb: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    carousel: {
      type: Array,
      required: false
    },
    heroImage: {
      type: String,
      required: false
    },
    badgeImage: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      model: 0,
      imagesLoaded: false,
      imagesLoading: false,
      loadingProgress: 0
    }
  },
  computed: {
    singleCarouselImage() {
      // If carousel has exactly one image, return its URL to display as static image
      if (this.carousel?.length === 1 && this.carousel[0]?.url) {
        return this.carousel[0].url
      }
      return null
    },
    breadcrumbItems() {
      const raw = (this.breadcrumb || '').trim()
      if (!raw) return []

      // Expected formats:
      // - "Home / Tours / Africa / Some Tour"
      // - "Resources / Top 10 Lists"
      // - "Rider Stories / Video Series"
      const parts = raw
        .split('/')
        .map(part => part.trim())
        .filter(Boolean)

      if (!parts.length) return []

      const routePath = this.$route?.path || '/'
      const routeSegments = routePath.split('/').filter(Boolean)
      const currentPath = routePath
      const hasHome = (parts[0] || '').toLowerCase() === 'home'

      return parts.map((label, idx) => {
        const cleanLabel = String(label || '').trim()
        const isLast = idx === parts.length - 1

        let to = '/'
        if (hasHome && idx === 0) {
          to = '/'
        } else {
          // If breadcrumb starts with "Home", crumb[1] maps to first route segment.
          // If it doesn't, crumb[0] maps to first route segment.
          const desiredSegmentCount = hasHome ? idx : idx + 1
          const safeSegmentCount = Math.min(Math.max(desiredSegmentCount, 0), routeSegments.length)
          to = safeSegmentCount ? `/${routeSegments.slice(0, safeSegmentCount).join('/')}` : '/'
        }

        // Link any non-last crumb that doesn't point at the current page,
        // except the second item which should never be clickable.
        const isSecond = idx === 1
        const isLink = Boolean(to) && !isLast && to !== currentPath && !isSecond

        return { label: cleanLabel, to, isLink }
      })
    }
  },
  mounted() {
    this.preloadImages()
  },
  watch: {
    heroImage: {
      handler() {
        this.preloadImages()
      },
      immediate: true
    },
    carousel: {
      handler() {
        this.preloadImages()
      },
      deep: true,
      immediate: true
    },
    badgeImage: {
      handler() {
        this.preloadImages()
      },
      immediate: true
    }
  },
  methods: {
    // Build a Vuetify v-img src (responsive WebP via the resize proxy, or the
    // original URL when the proxy is unavailable — dev/prerender/SVG/external).
    vImg(url, fallbackWidth = 1600) {
      return vuetifySrc(url, { fallbackWidth })
    },
    preloadImages() {
      // Reset loading state
      this.imagesLoaded = false
      this.imagesLoading = true
      this.loadingProgress = 0
      
      const imagesToPreload = []
      
      // Preload hero image (the LCP element) — use the resized variant so the
      // preload matches the request v-img actually makes.
      if (this.heroImage) {
        imagesToPreload.push(resizedUrl(this.heroImage, 1600))
      }
      
      // Preload badge image
      if (this.badgeImage) {
        imagesToPreload.push(resizedUrl(this.badgeImage, 400))
      }
      
      // Only preload the FIRST carousel image (above the fold). The remaining
      // slides lazy-load as the carousel cycles — preloading all of them here
      // forced multiple MB of downloads on mount and crushed LCP on mobile.
      if (this.carousel?.length && this.carousel[0]?.url) {
        imagesToPreload.push(resizedUrl(this.carousel[0].url, 1600))
      }
      
      if (imagesToPreload.length === 0) {
        this.imagesLoaded = true
        this.imagesLoading = false
        this.loadingProgress = 100
        return
      }
      
      // Preload all images and track progress
      let loadedCount = 0
      const totalImages = imagesToPreload.length
      
      const updateProgress = () => {
        loadedCount++
        this.loadingProgress = Math.round((loadedCount / totalImages) * 100)
        
        if (loadedCount === totalImages) {
          this.imagesLoaded = true
          this.imagesLoading = false
          // Small delay to show 100% before hiding
          setTimeout(() => {
            this.loadingProgress = 100
          }, 200)
        }
      }
      
      imagesToPreload.forEach(src => {
        if (src) {
          const img = new Image()
          img.onload = updateProgress
          img.onerror = updateProgress
          // Start loading
          img.src = src
        }
      })
    }
  }
}
</script>
<style lang="scss">
.breadcrumb-nav {
  display: inline;
}

.breadcrumb-item {
  color: inherit;
  text-decoration: none;
}

.breadcrumb-separator {
  display: inline-block;
  margin: 0 6px;
  color: inherit;
  text-decoration: none;
}

.breadcrumb-link {
  color: inherit !important;
  text-decoration: none;

  &:visited,
  &:active,
  &:focus {
    color: inherit;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

.hero-image-wrapper {
  width: 100%;
  max-width: 1904px;
  margin: 0 auto;
  padding: 0;
  
  @media (min-width: 960px) {
    padding: 0 min(5vw, 80px);
  }
}

.article-cover-image {
  overflow: hidden;
  width: 100%;
  border-radius: 0;
}

.rotate-left-15 {
  transform: rotate(-15deg);
}

.carousel-header {
  width: 100%;
  height: auto !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  
  .v-carousel__wrapper {
    height: auto !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
  
  .v-carousel__container {
    height: auto !important;
  }
  
  .v-carousel__item {
    height: auto !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
    width: 100%;
  }
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  
}
.carousel-badge {
  left: 2vw;
  bottom: 0;
  transform: translateY(50%);
}
.slogan-image {
  position: absolute;
  left: 50%;
  top: 50%;
  /* To perfectly center an absolutely-positioned element: */
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 600px;
}

.image-loading-progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  
  .progress-bar {
    margin: 0;
  }
}
</style>